import * as SwitchPrimitive from '@radix-ui/react-switch';
import PropTypes from 'prop-types';
import React from 'react';
import { cn } from 'Utils/cn';

const Switch = React.forwardRef(function Switch({ className, size, ...props }, ref) {
    return (
        <SwitchPrimitive.Root
            ref={ref}
            data-slot="switch"
            className={cn(
                'peer data-[state=checked]:bg-dark-blue data-[state=unchecked]:bg-dark-blue/10 focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-[20px] w-[34px] shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
                size === 'small' && 'h-3.5 w-5',
                className,
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    'bg-white data-[state=checked]:shadow-none shadow-sm pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-1px)] data-[state=unchecked]:translate-x-[1px]',
                    size === 'small' && 'size-2.5 data-[state=checked]:translate-x-[calc(100%-3px)]',
                )}
            />
        </SwitchPrimitive.Root>
    );
});

Switch.propTypes = {
    className: PropTypes.string,
    checked: PropTypes.bool,
    onCheckedChange: PropTypes.func,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    size: PropTypes.oneOf(['small', 'default']),
};

export default Switch;
